export const ePurchaseOrderMode: { [key: string]: string } = {
    AIR: 'Air',
    OCEAN: 'Ocean',
    INLAND: 'Inland'
};
